export const place_types_lange={
    TH:{
        back_to_place_type:"กลับไปหน้าแสดงข้อมูลชนิดที่อยู่",
        place_type_id:"รหัสชนิดที่อยู่",
        place_type_description:"รายละเอียดชนิดที่อยู่",
        alert_place_type_description:"กรุณากรอกรายละเอียดชนิดที่อยู่",
        save_data:"บันทึกข้อมูล",
        place_type:"จัดการข้อมูลชนิดที่อยู่",
        add_place_type:"เพิ่มข้อมูลชนิดที่อยู่",
        edit:"แก้ไข",
        delete:"ลบ",
        no_internet:"เกิดข้อผิดพลาดในการดึงข้อมูล กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตของคุณ!",
        saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว!",
        confirm_delete:"คุณต้องการลบข้อมูลชนิดที่อยู่นี้ใช่หรือไม่?",
        warning_delete:"ข้อมูลถูกลบแล้วไม่สามารถย้อนกลับได้",
        want_delete:"ฉันต้องการลบ",
        close_page:"ปิดหน้านี้",
        deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว!",
        search:"ค้นหา"


    },
    EN:{
        back_to_place_type:"back to show place type data",
        place_type_id:"place type id",
        place_type_description:"place type description",
        alert_place_type_description:"please input the place type description",
        save_data:"save data",
        place_type:"Place tyle data",
        add_place_type:"add place type",
        edit:"edit",
        delete:"delete",
        no_internet:"Error while change your data please check your internet connection!",
        saved:"data was saved!",
        confirm_delete:"Are you sure to delete this place type data?",
        warning_delete:"deleted data can't recovery!",
        want_delete:"delete this data",
        close_page:"close",
        deleted:"data was deleted!",
        search:"search"

    }
}
